import { render, staticRenderFns } from "./MarkBookRow.vue?vue&type=template&id=6f72d4fa&scoped=true&"
import script from "./MarkBookRow.vue?vue&type=script&lang=js&"
export * from "./MarkBookRow.vue?vue&type=script&lang=js&"
import style0 from "./MarkBookRow.vue?vue&type=style&index=0&id=6f72d4fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72d4fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
